// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NE5Ep","progressCont":"styles_progressCont__I73-V","progress":"styles_progress__ErGBU","remaining":"styles_remaining__RItDM"};